export enum RobotSystemComponentType {
  ROBOTARM = 'ROBOTARM',
  HCONTROL = 'HCONTROL',
  HPANEL = 'HPANEL',
}
